import {
  AttachMoney,
  CalendarToday,
  Description,
  Info,
} from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
import EnhancedTable from 'lib/designSystem/Table';
import TableWithPagination from 'lib/designSystem/TableWithPagination';
import { formatMoney } from 'lib/functions/utils';
import React from 'react';

import InfoRow from './InfoRow';

interface CollectionsSectionProps {
  totalPaid: number | null;
  paidOverdue: number | null;
  paidPrincipal: number | null;
  totalDiscounted: number | null;
  conciliationLog?: any[];
}

const CollectionsSection: React.FC<CollectionsSectionProps> = ({
  totalPaid,
  paidOverdue,
  paidPrincipal,
  totalDiscounted,
  conciliationLog = [],
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          backgroundColor: 'rgba(255, 152, 0, 0.08)',
          borderRadius: '8px',
          px: 1.5,
          py: 0.8,
          border: '1px solid rgba(255, 152, 0, 0.15)',
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            color: 'warning.main',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'center',
          }}
        >
          Recaudaciones
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: 6, justifyContent: 'flex-start' }}>
        {/* <InfoRow
          label="Total flujo"
          value={totalPaid ? formatMoney(totalPaid) : null}
          maxLength={40}
          icon={
            <AttachMoney sx={{ fontSize: '0.8rem', color: 'warning.main' }} />
          }
        /> */}
        <InfoRow
          label="Abono Capital"
          value={paidPrincipal ? formatMoney(paidPrincipal) : null}
          maxLength={40}
          icon={
            <AttachMoney sx={{ fontSize: '0.8rem', color: 'warning.main' }} />
          }
        />
        <InfoRow
          label="Mora calculada"
          value={paidOverdue ? formatMoney(paidOverdue) : null}
          maxLength={40}
          icon={
            <AttachMoney sx={{ fontSize: '0.8rem', color: 'warning.main' }} />
          }
        />
        <InfoRow
          label="Monto Condonado"
          value={totalDiscounted ? formatMoney(totalDiscounted) : null}
          maxLength={40}
          icon={
            <AttachMoney sx={{ fontSize: '0.8rem', color: 'warning.main' }} />
          }
        />
      </Box>

      <Box sx={{ mt: 2 }}>
        <EnhancedTable
          data={conciliationLog}
          dataHeaders={[
            { label: 'ID operación', key: 'requestId' },
            { label: 'Tipo de operación', key: 'typeEsp' },
            { label: 'Pagado por', key: 'paidBy' },
            { label: 'Fecha', key: 'date', type: 'date' },
            { label: 'Monto', key: 'amount', type: 'money' },
            {
              label: 'Capital',
              key: 'conciliationDocumentAmount',
              type: 'money',
            },
            { label: 'Mora', key: 'conciliationArrearAmount', type: 'money' },
          ]}
          finalSumRow
        />
      </Box>
    </Box>
  );
};

export default CollectionsSection;
